import axios from "axios";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

/** Aborted in-flight requests (pagination, Strict Mode, tab change) — not a real network failure. */
function isRequestAborted(error) {
  if (error == null) return false;
  if (error.code === "ERR_CANCELED") return true;
  if (error.name === "CanceledError" || error.name === "AbortError") return true;
  return false;
}

const url = "https://staging.api.naseebi.fastholidays.org/v3";
// const url = "http://localhost:8100/v3";
// const url = "https://api.naseebi.com/v3";
const axiosInstance = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      let token = localStorage.getItem("token") || Cookies.get("naseebiadmin");

      if (token) {
        token = token.replace(/["',]/g, "");
        config.headers.set("Authorization", `Bearer ${token}`);
      }
    }

    if (config.data instanceof FormData) {
      config.headers.set("Content-Type", "multipart/form-data");
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isRequestAborted(error)) {
      return Promise.reject(error);
    }
    if (!error.response) {
      toast.error("Network error. Check your connection and try again.");
    }
    if (error.response?.status === 401) {
      console.warn("Unauthorized! Redirecting to login...");
      //   if (typeof window === "undefined") {
      //     localStorage.removeItem("token");
      //     Cookies.remove("token");
      //     window.location.href = "/login";
      //   }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
